export const Careers = () => {
  return (
    <section className="py-14 bg-gray-50 text-center">
      <h2 className="text-4xl font-bold mb-6">Career Opportunities</h2>

      <p className="text-gray-600 max-w-3xl mx-auto mb-10">
        We provide a direct career path from training to internship to job placement.
        Students can work part-time while studying and gain industry experience.
      </p>

      <button className="px-8 py-3 bg-purple-600 text-white rounded-xl">
        Explore Careers
      </button>
    </section>
  );
};